import { CheckRounded, ContentCopyRounded } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import useStateCooldown from '../../../hooks/useStateCooldown';

interface Props {
  content: string;
  onCopy?: () => void;
}

function CopyButton({ content, onCopy }: Props) {
  const [copied, setCopied] = useStateCooldown(1000);

  const onClickCopy = () => {
    try {
      navigator.clipboard.writeText(content);
      setCopied(true);
      onCopy?.();
    } catch {
      // Do nothing
    }
  };

  return (
    <Button
      sx={{ padding: 1, flexShrink: 0 }}
      variant="light"
      color="secondary"
      onClick={onClickCopy}
      disabled={copied}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={0.5}
        sx={{
          opacity: copied ? 0 : 1,
        }}>
        <Typography variant="inherit" fontWeight="bold">
          Copy
        </Typography>
        <ContentCopyRounded color="secondary" width={8} height={8} />
      </Box>
      {copied && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center">
          <CheckRounded color="secondary" width={12} />
        </Box>
      )}
    </Button>
  );
}

export default CopyButton;
